export const companyInfo = {
  name: "ENSO",
  fullName: "ENSO SPRL",
  email: "office@ensoinsolv.ro",
  phone: "+40 742 124 002",
  address: "P-\u021ba Charles de Gaulle, nr. 15, et. 3, Sector 1, Bucure\u0219ti",
  registrationNumber: "5289",
};

export const heroStats = [
  { value: "15+", labelKey: "hero_stat_years" },
  { value: "1,500+", labelKey: "hero_stat_cases" },
  { value: "4", labelKey: "hero_stat_offices" },
];

export const services = [
  {
    id: 1,
    number: "01",
    title: { en: "Liquidation", ro: "Lichidare" },
    description: {
      en: "Liquidator in procedures provided by Law no. 31/1990, ensuring the complete and efficient winding-up of company operations with maximum creditor recovery.",
      ro: "Lichidator \u00een procedurile prev\u0103zute de Legea nr. 31/1990, asigur\u00e2nd lichidarea complet\u0103 \u0219i eficient\u0103 a opera\u021biunilor companiei cu recuperare maxim\u0103 a crean\u021belor.",
    },
    icon: "FileText",
  },
  {
    id: 2,
    number: "02",
    title: { en: "Preventive Conciliation", ro: "Concordat Preventiv" },
    description: {
      en: "Acting as conciliation administrator to facilitate consensus agreements between distressed entities and their creditors through strategic negotiations.",
      ro: "Ac\u021bion\u00e2nd ca administrator concordatar pentru a facilita acorduri consensuale \u00eentre entit\u0103\u021bile aflate \u00een dificultate \u0219i creditorii lor prin negocieri strategice.",
    },
    icon: "ShieldCheck",
  },
  {
    id: 3,
    number: "03",
    title: { en: "Insolvency Procedure", ro: "Procedura Insolven\u021bei" },
    description: {
      en: "Serving as judicial administrator to guide companies through insolvency proceedings with expertise, precision, and full transparency.",
      ro: "Serv\u00eend ca administrator judiciar pentru a ghida companiile prin procedurile de insolven\u021b\u0103 cu expertiz\u0103, precizie \u0219i transparen\u021b\u0103 deplin\u0103.",
    },
    icon: "Landmark",
  },
  {
    id: 4,
    number: "04",
    title: { en: "Bankruptcy", ro: "Faliment" },
    description: {
      en: "Acting as judicial liquidator, managing bankruptcy proceedings to maximize creditor recovery while maintaining strict legal compliance.",
      ro: "Ac\u021bion\u00e2nd ca lichidator judiciar, gestion\u00e2nd procedurile de faliment pentru maximizarea recuper\u0103rii crean\u021belor \u00een conformitate strict\u0103 cu legisla\u021bia.",
    },
    icon: "Hammer",
  },
];

export const stats = [
  {
    id: 1,
    value: 85,
    suffix: "%",
    label: { en: "Asset Valorization", ro: "Valorificare Active" },
    description: {
      en: "Valorizing assets at their appraised value",
      ro: "Valorificarea activelor la valoarea de evaluare",
    },
  },
  {
    id: 2,
    value: 65,
    suffix: "%",
    label: { en: "Debt Recovery", ro: "Recuperare Crean\u021be" },
    description: {
      en: "Ensuring all steps for effective debt recovery",
      ro: "Asigurarea tuturor pa\u0219ilor pentru recuperarea eficient\u0103 a crean\u021belor",
    },
  },
  {
    id: 3,
    value: 95,
    suffix: "%",
    label: { en: "Guarantee Protection", ro: "Protec\u021bie Garan\u021bii" },
    description: {
      en: "Preserving and protecting creditor guarantees",
      ro: "Prezervarea \u0219i protejarea garan\u021biilor creditorilor",
    },
  },
  {
    id: 4,
    value: 1500,
    suffix: "+",
    label: { en: "Cases Managed", ro: "Dosare Gestionate" },
    description: {
      en: "Successfully managed cases nationwide",
      ro: "Dosare gestionate cu succes la nivel na\u021bional",
    },
  },
];

export const team = {
  practitioners: [
    {
      name: "Dr\u0103gulin Marius-Ionu\u021b",
      role: { en: "Coordinating Associate", ro: "Asociat Coordonator" },
      description: { en: "Former coordinating associate at S.O.S. Insolv SPRL", ro: "Fost asociat coordonator la S.O.S. Insolv SPRL" },
    },
    {
      name: "F\u0103rc\u0103\u0219anu Adrian-C\u0103lin",
      role: { en: "Associate", ro: "Asociat" },
      description: { en: "Former associate at S.O.S. Insolv SPRL", ro: "Fost asociat la S.O.S. Insolv SPRL" },
    },
    {
      name: "Dr\u0103gulin R\u0103zvan-Alin",
      role: { en: "Associate", ro: "Asociat" },
      description: { en: "Former associate at Inviro Insolvency IPURL", ro: "Fost asociat la Inviro Insolvency IPURL" },
    },
    {
      name: "Dumitru Silviu",
      role: { en: "Associate", ro: "Asociat" },
      description: { en: "Former associate at Progessio SPRL", ro: "Fost asociat la Progessio SPRL" },
    },
    {
      name: "Screciu Daniela-Maria",
      role: { en: "Associate", ro: "Asociat" },
      description: { en: "Insolvency Practitioner", ro: "Practician \u00een Insolven\u021b\u0103" },
    },
  ],
  lawyers: [
    { name: "Andreea Mi\u0219coi", role: { en: "Lawyer", ro: "Avocat" } },
    { name: "Phoebe-An Romee", role: { en: "Lawyer", ro: "Avocat" } },
    { name: "Olteanu Robert-Nicu", role: { en: "Jurist", ro: "Jurist" } },
    { name: "B\u0103di\u021b\u0103 Sebastian", role: { en: "Jurist", ro: "Jurist" } },
    { name: "Florea Alexandru", role: { en: "Jurist", ro: "Jurist" } },
  ],
  support: [
    { name: "Nicoleta Dr\u0103gulin", role: { en: "Accounting", ro: "Contabilitate" } },
    { name: "Contabilink Hr SRL", role: { en: "Accounting Partner", ro: "Partener Contabilitate" } },
    { name: "Mail Professional SRL", role: { en: "Document Processing", ro: "Prelucrare Documente" } },
    { name: "Ionu\u021b Stoian", role: { en: "IT", ro: "IT" } },
  ],
};

export const portfolio = [
  { company: "NETWORK PRESS CONCEPT S.A", former: "formerly RODIPET S.A", formerRo: "anterior RODIPET S.A", debts: "240M RON", assets: "50M RON" },
  { company: "HSPTRANS", debts: "57M RON", assets: "20M RON" },
  { company: "VLD GROUP", debts: "30M RON", assets: "17M RON" },
  { company: "CIBROSAT SA", debts: "11M RON", assets: "30M RON" },
  { company: "BISMOBIL KITCHEN GROUP", note: { en: "10 companies", ro: "10 companii" }, debts: "7M RON", assets: "300K RON" },
  { company: "A.G.C. SRL", debts: "7M RON", assets: "1.4M RON" },
  { company: "EMT Group", note: { en: "27 companies", ro: "27 companii" }, debts: "7M RON", assets: "100K RON" },
  { company: "LUXORCOMP SRL", debts: "5M RON", assets: "1M RON" },
  { company: "RONDACO", debts: "200K RON", assets: "1.5M RON" },
];

export const objectives = [
  {
    number: "01",
    title: { en: "Maximize Valorization", ro: "Maximizare Valorificare" },
    titleRo: "Maximizare",
    description: {
      en: "Maximizing asset valorization and debt recovery for all stakeholders involved in the procedure.",
      ro: "Maximizarea valorific\u0103rii activelor \u0219i recuper\u0103rii crean\u021belor pentru to\u021bi p\u0103r\u021bile implicate \u00een procedur\u0103.",
    },
    icon: "TrendingUp",
  },
  {
    number: "02",
    title: { en: "Speed & Efficiency", ro: "Celeritate \u0219i Eficien\u021b\u0103" },
    titleRo: "Celeritate",
    description: {
      en: "Ensuring an efficient and timely procedure execution to minimize costs and maximize outcomes.",
      ro: "Asigurarea unei execu\u021bii eficiente \u0219i la timp a procedurii pentru minimizarea costurilor \u0219i maximizarea rezultatelor.",
    },
    icon: "Clock",
  },
  {
    number: "03",
    title: { en: "Transparency", ro: "Transparen\u021b\u0103" },
    titleRo: "Transparen\u021b\u0103",
    description: {
      en: "Permanently informing creditors about the procedure's progress through regular detailed reports.",
      ro: "Informarea permanent\u0103 a creditorilor despre evolu\u021bia procedurii prin rapoarte detaliate regulate.",
    },
    icon: "Eye",
  },
  {
    number: "04",
    title: { en: "Resource Assurance", ro: "Asigurarea Resurselor" },
    titleRo: "Resurse",
    description: {
      en: "Ensuring financial resources for the proper execution of all procedures, valorization, and recovery.",
      ro: "Asigurarea resurselor financiare pentru derularea corespunz\u0103toare a tuturor procedurilor, valorific\u0103rii \u0219i recuper\u0103rii.",
    },
    icon: "Briefcase",
  },
];

export const philosophy = [
  {
    title: { en: "Monthly Reporting", ro: "Raport\u0103ri Lunare" },
    description: {
      en: "Preparing comprehensive information reports for creditors on procedure progress.",
      ro: "Preg\u0103tirea rapoartelor informative comprehensive pentru creditori privind evolu\u021bia procedurii.",
    },
    icon: "FileText",
  },
  {
    title: { en: "Legal Opinions", ro: "Opinii Juridice" },
    description: {
      en: "Communicating legal opinions to creditors regarding procedures and necessary actions.",
      ro: "Comunicarea opiniilor juridice creditorilor cu privire la proceduri \u0219i ac\u021biunile necesare.",
    },
    icon: "BookOpen",
  },
  {
    title: { en: "Full Transparency", ro: "Transparen\u021b\u0103 Total\u0103" },
    description: {
      en: "All procedural acts are published in the Insolvency Procedures Bulletin (B.P.I.).",
      ro: "Toate actele procedurale sunt publicate \u00een Buletinul Procedurilor de Insolven\u021b\u0103 (B.P.I.).",
    },
    icon: "Eye",
  },
  {
    title: { en: "Strategic Consulting", ro: "Consultan\u021b\u0103 Strategic\u0103" },
    description: {
      en: "Presenting and consulting with creditors regarding the strategy for their guarantees.",
      ro: "Prezentarea \u0219i consultarea cu creditorii privind strategia pentru garan\u021biile lor.",
    },
    icon: "Compass",
  },
];

export const offices = [
  {
    city: "Bucure\u0219ti",
    type: { en: "Headquarter", ro: "Sediul Central" },
    address: "P-\u021ba Charles de Gaulle, nr. 15, et. 3, Sector 1",
  },
  { city: "Craiova", type: { en: "Regional Office", ro: "Birou Regional" } },
  { city: "Rm. V\u00e2lcea", type: { en: "Regional Office", ro: "Birou Regional" } },
  {
    city: "Voluntari",
    type: { en: "Regional Office", ro: "Birou Regional" },
    note: { en: "Opening Soon", ro: "Deschidere \u00een Cur\u00e2nd" },
  },
];

export const procedureSteps = [
  {
    step: 1,
    title: { en: "Creditor Assessment", ro: "Stabilirea Masei Credale" },
    description: {
      en: "Establishing the creditor mass correctly and transparently.",
      ro: "Stabilirea corect\u0103 \u0219i transparent\u0103 a masei credale.",
    },
  },
  {
    step: 2,
    title: { en: "Asset Conservation", ro: "Conservarea Activelor" },
    description: {
      en: "Investing and conserving the debtor's assets.",
      ro: "Investirea \u0219i conservarea activelor debitorului.",
    },
  },
  {
    step: 3,
    title: { en: "Feasibility Analysis", ro: "Analiza Fezabilit\u0103\u021bii" },
    description: {
      en: "Establishing the feasibility of a Reorganization Plan or Entering Bankruptcy.",
      ro: "Stabilirea fezabilit\u0103\u021bii unui Plan de Reorganizare sau Intrarea \u00een Faliment.",
    },
  },
  {
    step: 4,
    title: { en: "Investor Attraction", ro: "Atragerea Investitorilor" },
    description: {
      en: "Attracting potential investors for recovery or asset valorization.",
      ro: "Atragerea poten\u021bialilor investitori pentru recuperare sau valorificarea activelor.",
    },
  },
  {
    step: 5,
    title: { en: "Maximize Recovery", ro: "Maximizarea Recuper\u0103rii" },
    description: {
      en: "Maximizing the coverage of the creditor mass.",
      ro: "Maximizarea acoperirii masei credale.",
    },
  },
];

export const marqueeWords = [
  "integrity",
  "transparency",
  "expertise",
  "strategy",
  "precision",
  "excellence",
];

export const founders = [
  { name: "Dr\u0103gulin Marius-Ionu\u021b", from: "S.O.S. Insolv SPRL" },
  { name: "F\u0103rc\u0103\u0219anu Adrian-C\u0103lin", from: "S.O.S. Insolv SPRL" },
  { name: "Dr\u0103gulin R\u0103zvan-Alin", from: "Inviro Insolvency IPURL" },
  { name: "Dumitru Silviu", from: "Progessio SPRL" },
];
